import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setMenuOpen(false); }, [pathname]);

  return (
    <header className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="container navbar-inner">
        <Link to="/" className="navbar-logo">
          <img src="/logo.png" alt="DEEP Health" className="navbar-logo-img" />
          <span className="navbar-logo-text">
            <span>DEEP</span> Health
          </span>
        </Link>

        <nav className={`navbar-links ${menuOpen ? 'open' : ''}`}>
          <a href="/#features" onClick={() => setMenuOpen(false)}>Features</a>
          <a href="/#how" onClick={() => setMenuOpen(false)}>How It Works</a>
          <a href="/#rewards" onClick={() => setMenuOpen(false)}>Rewards</a>
          <Link to="/privacy" onClick={() => setMenuOpen(false)}>Privacy</Link>
          <Link to="/terms" onClick={() => setMenuOpen(false)}>Terms</Link>
        </nav>

        <div className="navbar-right">
          <a
            href="https://play.google.com/store"
            target="_blank"
            rel="noreferrer"
            className="btn-primary navbar-cta"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M3.18 23.5c.28.16.6.24.94.22l.09-.05 11.16-6.44-2.42-2.42L3.18 23.5zm15.9-10.28L16.7 11.8l-2.66 2.66 2.65 2.65 2.4-1.39c.69-.4.69-1.06 0-1.5zM3.09.5C2.8.68 2.62 1 2.62 1.44v21.12c0 .44.18.76.47.94l.09.05 11.8-11.8L3.09.5zm10.33 10.96L4.06.8l9.71 5.6-2.42 2.42 2.07 2.64z"/>
            </svg>
            Download App
          </a>
          <button
            className={`hamburger ${menuOpen ? 'open' : ''}`}
            onClick={() => setMenuOpen(m => !m)}
            aria-label="Menu"
          >
            <span /><span /><span />
          </button>
        </div>
      </div>
    </header>
  );
}
